import { render, staticRenderFns } from "./quick-play-sheet.vue?vue&type=template&id=14cf7ddc&scoped=true"
import script from "./quick-play-sheet.vue?vue&type=script&lang=js"
export * from "./quick-play-sheet.vue?vue&type=script&lang=js"
import style0 from "./quick-play-sheet.vue?vue&type=style&index=0&id=14cf7ddc&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14cf7ddc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/gameclient/gameclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('14cf7ddc')) {
      api.createRecord('14cf7ddc', component.options)
    } else {
      api.reload('14cf7ddc', component.options)
    }
    module.hot.accept("./quick-play-sheet.vue?vue&type=template&id=14cf7ddc&scoped=true", function () {
      api.rerender('14cf7ddc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tai-xiu/quick-play-sheet.vue"
export default component.exports